// TODO: replace with API hook once the audit-history endpoint is wired
// (see BFF route: GET /api/dsc-workbench/approvals/{approvalId}/audit)

export type AuditTabId = "view-all-notes" | "pre-approval-history" | "advance" | "status-history";

export type AuditTab = {
  id: AuditTabId;
  label: string;
};

export const AUDIT_TABS: AuditTab[] = [
  { id: "view-all-notes", label: "View All Notes" },
  { id: "pre-approval-history", label: "Pre-Approval Change History" },
  { id: "advance", label: "Advance" },
  { id: "status-history", label: "Status History" },
];

// TODO: replace print-step5 with a real action hook once Print is wired (OR-23155 Phase 5)
export type ActionItem = {
  id: string;
  label: string;
};

export const MOCK_ACTION_ITEMS: ActionItem[] = [
  { id: "view-bureau", label: "View Bureau" },
  { id: "print-step5", label: "Print Step 5 Deal Summary" },
];
